import { createMetaDef } from '@exodus/asset'

import tokensParams from './tokens.js'

const name = 'mantle'
const displayName = 'Mantle'
const ticker = 'MNT'
const primaryColor = '#4E9D97'
const gradientColors = ['#4E9D97', '#60C5BD']
const gradientCoords = { x1: '0%', y1: '0%', x2: '100%', y2: '100%' }
const chainBadgeColors = gradientColors
const chainId = 5000

const gasLimit = 21e3 // enough to send ETH to a normal address
const contractGasLimit = 1e6 // used when estimateGas fails

const units = {
  wei: 0,
  Kwei: 3,
  Mwei: 6,
  Gwei: 9,
  szabo: 12,
  finney: 15,
  MNT: 18,
}

const assetType = 'ETHEREUM_LIKE'
const tokenAssetType = 'MNT_ERC20'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.mantle.xyz/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://explorer.mantle.xyz/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Mantle | Mass adoption of decentralized & token-governed technologies. With Mantle Network, Mantle Treasury, and token holder-governed product initiatives.',
  website: 'https://mantle.xyz/',
  twitter: 'https://twitter.com/0xMantle/',
  reddit: 'https://www.reddit.com/r/0xMantle/',
  telegram: 'https://t.me/mantlenetwork/',
}

const assetParams = {
  assetType,
  blockExplorer,
  chainBadgeColors,
  chainId,
  contractGasLimit,
  displayName,
  gasLimit,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  ticker,
  tokenAssetType,
  units,
}

const tokenOverrides = (token) => ({
  ...token,
  contract: token.addresses,
  gasLimit: 120e3,
})

export const { asset, tokens, assetsList } = createMetaDef({
  assetParams,
  tokensParams,
  tokenOverrides,
})

export default assetsList
